import Api from '@/services/API';


/**
 * @typedef {CreatePassword}
 */

export default class CreatePassword extends Api {
  /**
   * @type {String}
   */
  static base = process.env.VUE_APP_API_HOST

  /**
   * @type {String}
   */
  static resource = '/member/new/create-password'

  /**
   * @param {String} resource
   * @param {Object} options
   * @param {Object} http
   */
  constructor(resource, options = {}, http = null) {
    super(CreatePassword.normalize(CreatePassword.base, resource), options, http);
  }

  /**
   * @return {this}
   */
  static build() {
    return new this(this.resource);
  }

  createPassword(email, document, password, confirmPassword) {
    let data = {
      email: email,
      document: document,
      password: password,
      confirm_password: confirmPassword
    }

    return this.post('', data);
  }
}